module.exports = __webpack_public_path__ + "img/PC_02.1f30833f.jpg";